import React, { FC, memo, useCallback } from 'react';

import WalletIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { useAccountModal } from '@rainbow-me/rainbowkit';

import { useAuth } from '@contexts/common/AuthorizationContext';
import { modalActions } from '@contexts/common/ModalContext';

import Button from '@components/common/Button';

import { Variant } from '@constants/common/ui.constants';

import useStyles from './styles.module';

interface Props {
  onOpen?: () => void;
  onClose: () => void;
  isOpen?: boolean;
}

const HeaderButtons: FC<Props> = ({
  onClose,
  onOpen,
  isOpen = true,
}: Props) => {
  const { classes } = useStyles();
  const { account } = useAuth();
  const { openAccountModal } = useAccountModal();

  return (
    <div className={classes.buttons}>
      {account ? (
        <Button
          onClick={openAccountModal}
          className={classes.button}
          variant={Variant.Icon}
        >
          <WalletIcon />
        </Button>
      ) : (
        <Button checkAuth className={classes.button} variant={Variant.Icon}>
          <WalletIcon />
        </Button>
      )}
      {/* <Button */}
      {/*  aria-label="close drawer" */}
      {/*  onClick={isOpen ? onClose : onOpen} */}
      {/*  className={classes.button} */}
      {/*  variant={Variant.Icon} */}
      {/* > */}
      {/*  {isOpen ? <CloseIcon /> : <MenuIcon />} */}
      {/* </Button> */}
    </div>
  );
};

export default memo(HeaderButtons);
